<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('lessons.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_lesson')"
                :title="$addLabel('lesson')"
                @click="openLessonModal()"
            />
        </app-page-top-section>

        <app-table
            id="lesson-table"
            :options="options"
            @action="triggerActions"
        />

        <app-lesson-modal
            v-if="isLessonModalActive"
            v-model="isLessonModalActive"
            :selected-url="selectedUrl"
            />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('lesson-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import LessonMixin from "../../../Mixins/Learning/LessonMixin";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import {LESSON_VIEW} from "../../../../Config/ApiUrl";

export default {
    name: "Lessons",
    mixins: [LessonMixin],
    props: {
        props: {
            default: ''
        },
        course_id: {
            type: String,
        }
    },
    data() {
        return {
            lesson: '',
            lessonsId: '',
            lessons: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            title: '',
            course_id: '',
            video_url: '',
            order: '',
            isLessonModalActive: false,
            confirmationModalActive: false,
            isEmployeeMovementModalActive: false,
        }
    },
    created() {
        this.$store.dispatch( 'lesson')
    },
    watch: {
        isLessonModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openLessonModal() {
            this.selectedUrl = '';
            this.isLessonModalActive = true;
        },
        triggerActions(row, action, active) {
            this.lessonsId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                console.log(action.url,'/',row.id)
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isLessonModalActive = true;
            } else if (action.key === 'view_details') {
                window.location = urlGenerator(`${LESSON_VIEW}/${row.id}`)
            }
            else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
    }
}
</script>
